import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Helmet } from "react-helmet-async";
import { RouterProvider } from "react-router";
import { syncOpenAiPixel } from "./lib/openaiPixel";
import { router } from "./router";

// Pixel da OpenAI Ads: só no site público (src/lib/openaiPixel.ts).
syncOpenAiPixel(window.location.pathname);
router.subscribe(state => syncOpenAiPixel(state.location.pathname));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Helmet
        defaultTitle="Fidexa"
        titleTemplate="%s | Fidexa"
      />
      <div className="font-sora bg-gray-50 text-gray-900 antialiased">
        <RouterProvider router={router} />
      </div>
    </QueryClientProvider>
  );
};
